import { BackOfficeDtoConverter } from 'shared/services/backoffice-data-provider';

import { Collection } from './models/Collection.model';

export class CollectionsDtoConverter extends BackOfficeDtoConverter {
  convert(dto: any) {
    return Collection.fromDto(dto) as any;
  }
}
